var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Audio"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Audio",
    clipPath: "url(#clip-Audio)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "audio_9899226",
    d: "M84.333,1H17.667A16.667,16.667,0,0,0,1,17.667V84.333A16.667,16.667,0,0,0,17.667,101H84.333A16.667,16.667,0,0,0,101,84.333V17.667A16.667,16.667,0,0,0,84.333,1ZM21,61a3.333,3.333,0,0,1-6.667,0V41A3.333,3.333,0,0,1,21,41ZM37.667,77.667a3.333,3.333,0,1,1-6.667,0V24.333a3.333,3.333,0,0,1,6.667,0ZM54.333,64.333a3.333,3.333,0,1,1-6.667,0V37.667a3.333,3.333,0,1,1,6.667,0ZM71,77.667a3.333,3.333,0,0,1-6.667,0V24.333a3.333,3.333,0,0,1,6.667,0ZM87.667,64.333a3.333,3.333,0,1,1-6.667,0V37.667a3.333,3.333,0,1,1,6.667,0Z",
    transform: "translate(-1 -1)",
    fill: "#e8eaf0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.bff4e49b0d51dc0a3775e534f9e09c12.svg";
export { ForwardRef as ReactComponent };